:host {
  @include cms-components-host-defaults;
}

.flowbox-inner {
  @include cms-default-grid-container;
}

.flowbox-wrapper,
.consent-container {
  grid-area: var(--cms-default-grid-area);
  height: auto;
}

// .flowbox-wrapper.basic {
//   min-height: calc(((100vw/2) - var(--cms-spacing-200)) * 4);
// }

// @media(min-width:527px) {
//   .flowbox-wrapper.basic {
//     min-height: calc(((100vw/4) - var(--cms-spacing-200)) * 4);
//   }
// }

// @media(min-width:1440px) {
//   .flowbox-wrapper.basic {
//     min-height: calc(((1440px/4) - var(--cms-spacing-200)) * 4);
//   }
// }